import script from "./HotkeyDoc.vue?vue&type=script&lang=ts&setup=true"
export * from "./HotkeyDoc.vue?vue&type=script&lang=ts&setup=true"

import "./HotkeyDoc.vue?vue&type=style&index=0&id=4b1afc5f&lang=scss&scoped=true"

import exportComponent from "C:\\work\\to-create\\bailing\\yc-bailing-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b1afc5f"]])

export default __exports__